<template>
<div>
    <el-form v-if="form" label-width="80px">
        <!-- 单选 -->
        <Radio v-if="form.questiontype == '1'" :formData='form' :type="type" @cancel="_cancel" @childSubmitFormApi='childSubmitFormApi'></Radio>
        <!-- 多选 || 不定项选择题-->
        <Checkbox v-if="form.questiontype == '2' || form.questiontype == '3'" :formData='form' @cancel="_cancel"  @childSubmitFormApi='childSubmitFormApi' :type="type"></Checkbox>
        <!-- <Checkbox v-if="form.questiontype == '3'" :form='form'></Checkbox> -->
        <!-- 判断题 -->
        <Judge v-if="form.questiontype == '4'" :formData='form' @cancel="_cancel" @childSubmitFormApi='childSubmitFormApi' :type="type"></Judge>
        <!-- 填空题 -->
        <Fill v-if="form.questiontype == '5'" :formData='form' @cancel="_cancel" @childSubmitFormApi='childSubmitFormApi' :type="type"></Fill>
        <!-- 问答题 -->
        <QuestionsAndAnswers v-if="form.questiontype == '6'" :formData='form' @cancel="_cancel" @childSubmitFormApi='childSubmitFormApi' :type="type"></QuestionsAndAnswers>
        <!--材料题-->
        <material v-if="form.questiontype == '7'" :formData='form' ref="material" @cancel="_cancel" @childSubmitFormApi='childSubmitFormApi' :type="type"></material>
    </el-form>

    <!--<div slot="footer" class="dialog-footer">-->
        <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
        <!--<el-button type="primary" @click="sureBtn()">保 存</el-button>-->
    <!--</div>-->
</div>
</template>

<script>
import {mapActions} from 'vuex'
import {getExamQuestionInfo,updateCwKmcQuestionbankExampaperinfo} from 'api/testPaperApi'
import Radio from 'views/operateTool/testpaper/components/quesType/Radio'
import Checkbox from 'views/operateTool/testpaper/components/quesType/Checkbox'
import Judge from 'views/operateTool/testpaper/components/quesType/Judge'
import Fill from 'views/operateTool/testpaper/components/quesType/Fill'
import QuestionsAndAnswers from 'views/operateTool/testpaper/components/quesType/QuestionsAndAnswers'
import Material from 'views/questionbank/components/material'
import {saveOrUpdateQuestionInfo, getQuestionInfo} from 'api/questionApi'
export default {
    name: "subEdit",
    props:{
        itemData:Object,
        itemIndex:Number
    },
    data(){
        return{
            type:'2',
            form: {},
        }
    },
    created(){
        this.$bus.on('topicCancel',()=>{
            this.$bus.emit('canceltopicEdit', {type:'cancel',ind:this.itemIndex});
        })
    },
    mounted() {
        this.form = this.itemData
    },
    methods: {
        cancel() {
        },
        _cancel() {
            this.itemData.editShow = false
        },
        sureBtn() {
            //编辑成功
            this.$bus.emit('sureEdit', 1)
        },
        childSubmitFormApi(api) {    // 子组件提交api方法
            this.$bus.emit('canceltopicEdit', {data:api,ind:this.itemIndex});
        },
        ...mapActions(['setLoading']),
    },
    watch: {},
    components:{
        Radio,Checkbox,Judge,Fill,QuestionsAndAnswers, Material
    }
}
</script>

<style scoped>

</style>
